module.exports = __webpack_public_path__ + "static/media/forAll.ca6773cf.png";